import React, { useEffect, useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import PHealth from '../../components/PHealth/PHealth';
import InfraHealth from '../../components/InfraHealth/InfraHealth';
import { useShellNav } from '../shell/ShellNavContext';
import { shellTokens } from '../shell/theme/shellTheme';

const PLATFORM_TABS = [
    { value: 'pipeline', label: 'Trading pipeline' },
    { value: 'infra', label: 'Fleet infra' },
];

const DEFAULT_TAB = PLATFORM_TABS[0].value;
const VALID_TABS = new Set(PLATFORM_TABS.map((tab) => tab.value));

const subTabSx = (active) => ({
    border: `1px solid ${active ? 'rgba(37, 99, 235, 0.25)' : shellTokens.border}`,
    bgcolor: active ? 'rgba(37, 99, 235, 0.1)' : shellTokens.surface,
    borderRadius: '8px',
    px: 1.75,
    py: 0.85,
    fontSize: '0.78rem',
    fontWeight: 700,
    color: active ? shellTokens.primary : shellTokens.muted,
    textTransform: 'none',
});

const PlatformPage = () => {
    const { subTab, setSubTab } = useShellNav();
    const [activeTab, setActiveTab] = useState(DEFAULT_TAB);

    useEffect(() => {
        if (subTab && VALID_TABS.has(subTab)) {
            setActiveTab(subTab);
        }
    }, [subTab]);

    const handleTabClick = (value) => {
        setActiveTab(value);
        setSubTab(value);
    };

    return (
        <Box>
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mb: 1.75 }}>
                {PLATFORM_TABS.map((tab) => (
                    <Button
                        key={tab.value}
                        sx={subTabSx(activeTab === tab.value)}
                        onClick={() => handleTabClick(tab.value)}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Stack>

            {activeTab === 'pipeline' ? <PHealth /> : null}
            {activeTab === 'infra' ? <InfraHealth /> : null}
        </Box>
    );
};

export default PlatformPage;
